import React, { useState, useEffect } from 'react'
import { Circles } from 'react-loader-spinner'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import noop from 'lodash/noop'
import AdminListTablePage from '../../../components/global/dataTable'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../../constants/globalConstants'
import { getDataBookingHistory } from '../../../redux/actions/bookingHistoryAction'
import ConfermationModal from '../../../components/global/ConfermationModal'
import moment from 'moment/moment'
import {
    downloadTicket,
    inventoryUpdateReservatino,
} from '../../../redux/actions/widgetReservationAction'
import { useNavigate } from 'react-router-dom'
import URL from '../../../constants/urls'
import { cancelReservation } from '../../../redux/actions/bookingHistoryAction'
import { isPermissionExist, sortPortalPermissionByKey } from '../../../utils/helper'
// import { renderNoResults } from '../../../components/global/NoDataFound'
import { errorMessage } from '../../../constants/errorMessage'
import PassWalletButtons from '../../../components/global/PassWalletButtons'
import { APICONFIG } from '../../../redux/config/apiConfig'

function BookingHistory(props) {
    const { partnerDetails } = props
    const [isLoading, setIsLoading] = useState(false)
    const [bookingData, setBookingData] = useState(EMPTY_ARRAY)
    const [search, setSearch] = useState('')
    const [loaderTicket, setLoaderTicket] = useState(false)
    const [confermationModal, setConfermationModal] = useState(false)
    // const [cancelResponce, setCancelResponce] = useState(false)
    const [TicketItem, setTicketItem] = useState(EMPTY_ARRAY)
    const navigate = useNavigate()
    const partner = window.location.toString().split('/')[3]

    const { current_page, per_page, dispatch, total, notify } = props
    const [actionTime, setActionTime] = useState(60)
    const [defaultTimeZone, setDefaultTimeZone] = useState('America/New_York')
    const [accessPermissions, setAccessPermissions] = useState('')
    const [displayError, setDisplayError] = useState(null)


    useEffect(() => {
        setDefaultTimeZone('America/New_York')
        getNewBookingList()
        setActionTime(60)
    }, EMPTY_ARRAY)

    useEffect(() => {
        const getAccessPermissionData = sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions')
        setAccessPermissions(getAccessPermissionData)
    }, [EMPTY_ARRAY, partnerDetails])


    const worldPortcolumns = [
        { header: 'Reservation Number', id: 'ticket_number', accessor: e => e?.ticketech_code ? e?.ticketech_code : '-', style: { minWidth: '5rem' } },
        { header: 'Facility Name/City', id: 'facility_name', accessor: e => e?.facility ? e.facility?.full_name + ' / ' + e.facility?.geolocations?.city : '-', style: { minWidth: '5rem' } },
        // { header: 'Check-in Date & Time', id: 'checkin_date', accessor: e => e?.created_at ? moment(e?.created_at).format('MM/DD/YYYY hh:mm A') : '-', style: { minWidth: '7rem' } },
        { header: 'Start Parking Date/Time', id: 'checkin_date', accessor: e => e?.start_timestamp ? moment(e?.start_timestamp).format('MM/DD/YYYY hh:mm A') : '-', style: { minWidth: '7rem' } },
        // { header: 'Start Parking Date/Time', id: 'checkin_date', accessor: e => e?.start_timestamp ? moment(e?.start_timestamp).format('MM/DD/YYYY HH:MM A') : '-', style: { minWidth: '7rem' } },
        { header: 'Check-out Date & Time', id: 'checkin_date', accessor: e => e?.end_timestamp ? moment(e?.end_timestamp).format('MM/DD/YYYY hh:mm A') : '-', style: { minWidth: '7rem' } },

        // { header: 'Amount', id: 'amount', accessor: e => '$' + e?.facility?.facility_configuration?.is_process_fee_charged == 1 ? e?.charged_amount : e?.total, style: { minWidth: '5rem' } },
        { header: 'Amount', id: 'amount', accessor: e =>  `$${e?.facility?.facility_configuration?.is_process_fee_charged == 1 ? e?.charged_amount : e?.total}`, style: { minWidth: '5rem' } },
        // { header: 'Vehicle', id: 'vehicle', accessor: e => e.is_allocated === 1 ? 'Yes' : 'No' },
        { header: 'Action', accessor: e => renderRowActions(e) }
    ]

    const handleEditBooking = (Id) => {
        if(window.location.toString().includes('iframe')){
            navigate(`/iframe/${partner}/${URL.BOOKING_EDIT_REDIRECT}/${Id}`)
        }else{
            navigate(`/${partner}/${URL.BOOKING_EDIT_REDIRECT}/${Id}`)
        }
        
    }


    const renderRowActions = (data) => {

        var bookHour = moment(new Date(data?.start_timestamp)).format('YYYY-MM-DDTHH:mm:ss')
        var todayhour = moment(new Date()).tz(`${data?.facility?.timezone ? data?.facility?.timezone : defaultTimeZone}`).format('YYYY-MM-DDTHH:mm:ss')
        let diffTime = Math.floor((new Date(bookHour).getTime() - new Date(todayhour).getTime()) / 60000)
        let actionCancel = data.facility?.facility_configuration?.before_cancel_time ? data.facility?.facility_configuration?.before_cancel_time : actionTime
        let resEndDate = moment(new Date(data.end_timestamp)).format('YYYY-MM-DDTHH:mm:ss')




        return (
            <div className="d-flex align-items-center justify-content-start gap-2 action-btn">
                {/* {diffTime} */}
                {(data?.cancelled_at !== null && data?.cancelled_at !== '') ? '' : <a className="btn btn-primary btn-sm" onClick={() => handleDownloadTicket(data, data?.id, data?.ticketech_code)} disabled={loaderTicket} >
                    <i className="fa fa-download"></i>
                </a>}
                {/* {actionCancel} */}
                {/* {(partner == 'mapco' || partner == 'roc') ? <> */}
                {/* {isPermissionExist(accessPermissions, 'Reservation Booking Edit') && !data.cancelled && resEndDate>todayhour &&  data.is_ticket!='2' && <a title="Edit" className="btn btn-warning btn-sm" href="#" onClick={(event) => { */}
                {(isPermissionExist(accessPermissions, 'Reservation Booking Edit') && (data?.cancelled_at == null || data?.cancelled_at == '') && resEndDate > todayhour && data.is_ticket != '2' && !data?.event_id) && <a title="Edit" className="btn btn-warning btn-sm" href="#" onClick={(event) => {

                    event.stopPropagation()
                    event.preventDefault()
                    handleEditBooking(data.id)
                }}>
                    <i className="fa fa-pencil" aria-hidden="true"></i>
                </a>}

                <PassWalletButtons
                    ticketId={data?.ticketech_code}
                    googleWalletApi={APICONFIG.getGoogleReservationPassDownload}
                    appleWalletApi={APICONFIG.getappleReservationPassDownload}
                    notify={notify}
                    isAction
                    partnerDetails={partnerDetails}
                />

                {/* {isPermissionExist(accessPermissions, 'Reservation Booking Cancel')  ? (data.cancelled) ? <small className="text-danger"> Cancelled </small>  */}
                {isPermissionExist(accessPermissions, 'Reservation Booking Cancel') ? (data?.cancelled_at !== null && data?.cancelled_at !== '') ? <small className="text-danger"> Canceled </small>

                    : (Number(diffTime) > Number(actionCancel)) ?
                        <a title='Ticket Cancel' className="btn btn-danger btn-sm"
                            onClick={(e) => handleCancelTicket(e, data)}

                            disabled={loaderTicket}
                        >
                            <i className="fas fa-calendar-times"></i>
                        </a> : ''

                    : ''}
                {/* </>:''} */}

            </div>
        )
    }

    const handleDownloadTicket = (data, Id, ticketNumber) => {
        const is_event = data?.event_id && data?.event_id != null
        if (!loaderTicket) {
            setLoaderTicket(true)
            dispatch(downloadTicket(Id, ticketNumber, is_event)).then((res) => {
                setLoaderTicket(false)
                if (res?.status && res?.status == 500) {
                    //notify('error', 'Something went wrong, Please try again!')
                }
                // notify('Success', 'E-Ticket Downloaded')
            }).catch(() => {
                setLoaderTicket(false)
                // notify('error', 'Something went wrong, Please try again!')
            })
        }


    }
    // const renderRowActions = (data) => {
    //     return (
    //       <div className="d-flex action-btn">
    //         <a title="Edit" className="m-1 mt-0" href="#" onClick={(event) => {
    //           event.stopPropagation();
    //           event.preventDefault();
    //           getUpdate(data.id)
    //         }}>
    //           <i className="bi bi-pencil-fill edit"></i>
    //         </a>
    //         {(data.is_allocated !== 1) && <a title="Delete" className="mt-0 ms-2" href="#" onClick={(event) => {
    //           event.stopPropagation();
    //           event.preventDefault();
    //           getDelete(data.id)
    //         }}>
    //           <i className="bi bi-trash3 delete"></i>
    //         </a>}
    //       </div>
    //     );
    //   };

    const getNewBookingList = (page = 1, search = '', sortBy = '', sortOrder = '') => {
        setIsLoading(true)
        setSearch(search)
        dispatch(getDataBookingHistory(page, search, sortBy, sortOrder)).then((res) => {
            if (res?.data && res?.data != null) {
                setBookingData(res?.data)
                setIsLoading(false)
            } else {
                setBookingData(EMPTY_ARRAY)
                setIsLoading(false)
                setDisplayError(res?.errors && res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
            }
        }).catch((err) => {
            setDisplayError(err?.errors && err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
        })
    }



    const handleCancelTicket = (e, item) => {
        e.preventDefault()
        setTicketItem(item)
        setConfermationModal(true)
    }

    // Delete Vehicle item
    const handleDelete = () => {
        if (TicketItem?.id) {
            setIsLoading(true)
            dispatch(cancelReservation(TicketItem?.id)).then((res) => {
                setIsLoading(false)
                if (res?.status && res?.status == 500) {
                    notify('error', res?.errors ? res?.errors?.message : 'Something went wrong, Please try again!')
                } else {
                    getNewBookingList()
                    notify('success', 'Your ticket has been canceled successfully!')
                    if (TicketItem?.facility?.facility_configuration?.is_inventory_check == '1') {
                        dispatch(inventoryUpdateReservatino({ 'reservation_id': TicketItem?.id, 'type': 2 })).then(() => {
                        })
                    }

                }
                // setCancelResponce(res)
            })
            setConfermationModal(false)
        }
    }




    return (
        <div>
            <div className="d-flex mb-2">
                <h4 className="fw-normal">Booking History </h4>
                <ConfermationModal setConfermationModal={setConfermationModal} confermationModal={confermationModal} confermationHeading='Cancel Ticket' confermationMessage='Are you sure you want to cancel this ticket?' buttonLable='Yes' handleDelete={handleDelete} />
            </div>
            {isLoading ? <span className='ms-6 d-flex justify-content-center loaderdesign section dashboard'><Circles
                height="700"
                width="50"
                color="var(--bs-primary)"
                ariaLabel="circles-loading"
                visible={true}
            /></span> :
                // bookingData?.length > 0 ? 
                <div className="card mb-3 table-responsive">
                    <div className="card-header"><b>Booking List</b></div>
                    <AdminListTablePage
                        data={bookingData}
                        columns={worldPortcolumns}
                        getNewRecords={getNewBookingList}
                        curPage={current_page}
                        perPage={per_page}
                        total={total}
                        showSearch={true}
                        search={search}
                        displayError={displayError}
                    />
                </div>
                //  : renderNoResults(displayError)
            }
        </div>
    )
}

BookingHistory.propTypes = {
    dispatch: noop,
    isAuthenticated: PropTypes.bool,
    userData: PropTypes.object,
    permitData: PropTypes.object,
    current_page: PropTypes.number,
    per_page: PropTypes.number,
    total: PropTypes.number,
    notify: PropTypes.func,
    partnerDetails: PropTypes.object,
}

BookingHistory.defaulProps = {
    isAuthenticated: false,
    userData: EMPTY_OBJECT,
    permitData: EMPTY_OBJECT,
    partnerDetails: EMPTY_OBJECT,
    notify: noop
}

function mapStateToProps({ bookingHistoryReducer }) {
    const { current_page, per_page, total } = bookingHistoryReducer
    return {
        current_page,
        per_page,
        total,
    }
}
export default connect(mapStateToProps)(BookingHistory)